export default "__VITE_ASSET__e2958ce0__"